module.exports = __webpack_public_path__ + "static/media/hot-noodles-ad2.7fb9c6e8.png";